import ActiveSchedule from './components/ActiveSchedule';
import { ScheduledLinesPropType } from './types';

const Page = ({ scheduledLines }) =>
  // Perfect place to use API call
  ActiveSchedule({ scheduledLines });

Page.propTypes = {
  scheduledLines: ScheduledLinesPropType,
};

export default Page;
